var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.couponExists,
          expression: "couponExists",
        },
      ],
      staticClass: "container-fluid",
      class: "container-fluid--" + _vm.colorTheme,
      style:
        "padding-top: " +
        _vm.top +
        "rem; padding-bottom: " +
        _vm.bottom +
        "rem;",
    },
    [
      _c(
        "div",
        {
          staticClass: "container",
          class: "container--" + (_vm.disabled ? "disabled" : ""),
        },
        [
          _c("h1", {
            staticClass: "container__title text--h4",
            domProps: { innerHTML: _vm._s(_vm.getParsedTitle) },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "container__content text--h6",
            domProps: { innerHTML: _vm._s(_vm.getParsedContent) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container__coupon coupon" }, [
            _c(
              "ul",
              { staticClass: "coupon__list" },
              _vm._l(_vm.coupons, function (coupon, key) {
                return _c(
                  "li",
                  {
                    key: key,
                    staticClass: "coupon__item",
                    style:
                      "background-color: " +
                      _vm.couponColor +
                      "; color: " +
                      _vm.couponTextColor,
                  },
                  [
                    _c("div", { staticClass: "coupon__inner" }, [
                      _c("div", { staticClass: "coupon__container" }, [
                        _c("div", { staticClass: "coupon__price" }, [
                          _c(
                            "h3",
                            { staticClass: "coupon__label text--content1" },
                            [_vm._v("COUPON")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class:
                                "coupon__price-point coupon__price-point--" +
                                _vm.couponType(coupon) +
                                " text--h3",
                            },
                            [
                              _vm.couponType(coupon) === "rate"
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayWithCommas(
                                          coupon.discountRate
                                        )
                                      )
                                    ),
                                  ]
                                : _vm._e(),
                              _vm.couponType(coupon) === "amount"
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayWithCommas(
                                          coupon.discountAmount
                                        )
                                      )
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("div", { staticClass: "coupon__name" }, [
                          _c("p", {
                            staticClass: "text--h6",
                            domProps: { innerHTML: _vm._s(coupon.title) },
                          }),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.showCouponCount
              ? _c(
                  "div",
                  { staticClass: "coupon__remaining" },
                  [
                    _vm.isActive ? [_vm._v(_vm._s(_vm.stock))] : _vm._e(),
                    _vm._v(" "),
                    !_vm.isActive ? [_vm._v("0")] : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container__button" }, [
            _c(
              "button",
              {
                staticClass: "container__button-cta button-cta",
                attrs: { disabled: _vm.isPending || _vm.disabled },
                on: { click: _vm.getCoupons },
              },
              [
                _c("span", { staticClass: "button-cta__icon-download" }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "button-cta__text" },
                  [
                    !_vm.isActive ? [_vm._v("쿠폰 기간 만료")] : _vm._e(),
                    _vm._v(" "),
                    _vm.isActive
                      ? [
                          _vm.hasCoupons
                            ? [_vm._v("쿠폰 발급 완료")]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hasCoupons && _vm.stock !== 0
                            ? [
                                _vm._v(
                                  _vm._s(_vm.buttonText || "쿠폰 모두 받기")
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hasCoupons && _vm.stock === 0
                            ? [_vm._v("쿠폰 재고 소진")]
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("popup", {
        attrs: {
          visible: _vm.visible,
          type: _vm.type,
          title: _vm.popupInfo.title,
          subtitle: _vm.popupInfo.subtitle,
          buttonText: "확인",
        },
        on: { close: _vm.load },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "coupon__dot-line dot-line dot-line--outer" },
      [_c("div", { staticClass: "dot-line dot-line--inner" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }